module.exports = __webpack_public_path__ + "img/826A59_E0C9B9_CBAD99_3D2615-256px.d0ea8725.png";